// components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./Auth";

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
